import { Component } from '@angular/core';
import { fadeInOut, routerTransition } from './shared/classes/animations';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './core/services/api.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    animations: [ routerTransition, fadeInOut ]
})
export class AppComponent {
    title = 'app';
    apiLoaded = false;
    configError = false;

    constructor(
        private apiService: ApiService,
        iconRegistry: MatIconRegistry,
        sanitizer: DomSanitizer,
        private translate: TranslateService
    ) {
        this.apiService.getInstanceConfig()
        .subscribe(retour => {
            this.apiLoaded = true;
        },
        error => {
            this.configError = true;
        });

        translate.setDefaultLang('fr');
        translate.use('fr');

        iconRegistry.addSvgIcon('flag-fr', sanitizer.bypassSecurityTrustResourceUrl('/assets/flags/fr.svg'));
        iconRegistry.addSvgIcon('flag-en', sanitizer.bypassSecurityTrustResourceUrl('/assets/flags/en.svg'));
        iconRegistry.addSvgIcon('flag-lu', sanitizer.bypassSecurityTrustResourceUrl('/assets/flags/lu.svg'));
        iconRegistry.addSvgIcon('flag-nl', sanitizer.bypassSecurityTrustResourceUrl('/assets/flags/nl.svg'));
        iconRegistry.addSvgIcon('flag-de', sanitizer.bypassSecurityTrustResourceUrl('/assets/flags/de.svg'));
        iconRegistry.addSvgIcon('flag-pt', sanitizer.bypassSecurityTrustResourceUrl('/assets/flags/pt.svg'));
        iconRegistry.addSvgIcon('flag-es', sanitizer.bypassSecurityTrustResourceUrl('/assets/flags/es.svg'));
        iconRegistry.addSvgIcon('format-size', sanitizer.bypassSecurityTrustResourceUrl('/assets/format_size.svg'));
    }

    prepareRouteTransition(outlet) {
        const animation = outlet.activatedRouteData['animation'] || {};
        return animation['value'] || null;
    }

    getState(outlet) {
        return outlet.activatedRouteData.state;
    }
}
